import { Component } from '@angular/core';
import { Store } from '@ngxs/store';
import { SetCookieEnabled } from '../../action/state.action';
import { AppInformationService } from '../../service/app-info.service'

@Component({
	selector: 'cv-change-state',
	templateUrl: './change-state.component.html',
	styles: ['.container {margin: 5px 0; padding : unset; span {margin-left : 9px} }']
})
export class ChangeStateComponent {
	initialValue = this.store.selectSnapshot<boolean>((state) => state.app.invisionUX.cookieEnable);

	constructor(private store: Store, private appInfo: AppInformationService) {
	}

	onValueChange(isChecked: boolean): void {
		this.store.dispatch(new SetCookieEnabled(isChecked, this.appInfo.appName));
	}
}
